import { Link } from 'react-router-dom';
import runityLogo from '../assets/runity-logo.svg';
import { EVENT_LIST_ROUTE_PATH } from '../routes/appRoutes';

function BrandLogo() {
  return (
    <Link className="brand" to={EVENT_LIST_ROUTE_PATH} aria-label="대회 목록으로 이동">
      <img className="brand-logo" src={runityLogo} alt="" aria-label="RUNITY 로고" />
    </Link>
  );
}

export default BrandLogo;
